<template>
  <div>
    <template v-if="!user">
      <cp-box>
        <cp-box-content>
          <cp-grid>
            <cp-grid-item :span="$root.isMobile ? 12 : 6">
              <cp-sign-info
                icon="fa-signal-stream"
                title="Start a Livestream"
                step1Title="Sign Up or Log In"
                step1Description="Begin by creating your account or logging in to get started."
                step2Title="Set Up Your Livestream"
                step2Description="Prepare to go live. Set up your livestream to engage your audience."
                step3Title="Share Your Thoughts"
                step3Description="Connect in real-time. Start sharing your thoughts, ideas, and discussions with your audience."
              />
            </cp-grid-item>
            <cp-grid-item :span="$root.isMobile ? 12 : 6">
              <cp-auth-form style="margin:0 auto" :return-url="returnUrl" login-type="return_url"></cp-auth-form>
            </cp-grid-item>
          </cp-grid>
        </cp-box-content>
      </cp-box>
    </template>
    <template v-else>
      <div v-if="step == 'add-title'" class="container-livestream">
        <div class="box-livestream">
          <div>
            <h2 style="margin: 0; color: #404040">Start livestream</h2>
            <h4 style="color: #404040">Livestream title <span style="color: #ed572f">*</span></h4>
            <p class="content-3">Adding a title will make it easier for friends to know what this livestream is about.</p>

            <cp-text-input style="margin-bottom: 15px" name="title" v-model="title" placeholder="Type here ..." block round></cp-text-input>
          </div>

          <div style="display: flex">
            <cp-button block :loading="false" @click="goBack" style="margin-right: 5px">
              <span class="content-4">Back</span>
            </cp-button>
            <cp-button block primary :disabled="!title" :loading="false" @click="() => setStep('start-livestream')" style="margin-left: 5px">
              <span class="content-4">Start</span>
            </cp-button>
          </div>
        </div>
      </div>
      <div v-else-if="step == 'start-livestream'" class="container-start-livestream">
        <div class="header">
          <div style="display: flex; align-items: center">
            <img class="user-image" :src="user.profile_image" />

            <p class="content-2" style="color: #fcd9d0; margin-right: 15px">{{ user.name }}</p>

            <span class="content-2 viewer-badge">
              <cp-icon name="clock" style="margin-right: 3px"></cp-icon>
              <span>{{ displayTime }}</span>
            </span>

            <span class="content-2 viewer-badge" style="margin-left: 5px">
              <cp-icon name="eye" style="margin-right: 3px"></cp-icon>
              {{ liveViewers }}
            </span>
          </div>

          <cp-button v-if="streamSession" primary :loading="false" @click="handleEndLivestreamModal">
            <span class="content-4">End livestream</span>
          </cp-button>
        </div>

        <div class="body">
          <div class="video-content">
            <div id="publisher"></div>
          </div>

          <div v-if="showChat" class="chat-content">
            <p class="content-5" style="color: white; margin: 0">Live Chat</p>
          </div>
        </div>

        <div class="footer">
          <div>
            <p class="content-5" style="color: white">Let’s talk about {{ title }}</p>
          </div>

          <!-- <span class="content-2" style="color: white; cursor: pointer" @click="handleChat">
                    {{ 'Live Chat' }}
                    <cp-icon :name="showChat ? 'comment-slash' : 'comment-dots'" class="icon"></cp-icon>
                </span> -->
        </div>

        <!-- End Modal -->
        <cp-dialog v-if="showStreamEndedModal">
          <div class="container-modal">
            <h3 style="margin: 0; color: #404040">End livestream</h3>
            <p class="content-3">Are you sure you want to end this livestream?</p>

            <div style="display: flex; margin-top: 40px">
              <cp-button block @click="handleEndLivestreamModal" style="margin-right: 5px">
                <span class="content-4">Cancel</span>
              </cp-button>
              <cp-button block primary @click="stopLivestream" style="margin-left: 5px">
                <span class="content-4">End</span>
              </cp-button>
            </div>
          </div>
        </cp-dialog>

        <!-- Livestream starting Modal -->
        <cp-dialog v-if="showStartingLivestreamModal">
          <div class="container-modal" style="margin-left: 50px; margin-right: 50px">
            <div v-if="!errorStartingLivestream" class="spinner">
              <div class="spinner-inner"></div>
            </div>

            <p v-if="!errorStartingLivestream" class="content-3">Starting livestream ...</p>
            <p v-else class="content-3" style="color: #ed572f">{{ errorStartingLivestream }}</p>

            <div v-if="errorStartingLivestream" style="margin-top: 40px">
              <cp-button block primary @click="handleErrorStartingLivestream" style="margin-left: 5px">
                <span class="content-4">Ok</span>
              </cp-button>
            </div>
          </div>
        </cp-dialog>
      </div>
      <div v-else class="container-livestream">
        <div class="box-livestream" style="align-items: center">
          <div style="text-align: center">
            <h2 style="color: #404040">Livestream ended!</h2>
            <p class="subheadline1 neutral4-color">Relive the moment by saving and sharing it on CrowdBlue TV!</p>
          </div>

          <img src="/assets/img/icons/icon-livestream.svg" width="100" height="100" alt="" />

          <div style="width: 70%">
            <cp-button :loading="loadingSaveLivestream" block primary @click="saveLivestream">
              <span class="content-4">Save and share video</span>
            </cp-button>
            <cp-button block @click="discardLivestream" style="margin-top: 10px">
              <span class="content-4">Discard video</span>
            </cp-button>
          </div>
        </div>

        <!-- Discard Modal -->
        <cp-dialog v-if="showDiscardModal">
          <div class="container-modal">
            <h3 style="margin: 0; color: #404040">Are you sure you want to discard this livestream?</h3>
            <p class="content-3">This action is permanent and it cannot be undone.</p>

            <div style="display: flex; margin-top: 40px">
              <cp-button block @click="() => (this.showDiscardModal = false)" style="margin-right: 5px">
                <span class="content-4">Cancel</span>
              </cp-button>
              <cp-button :loading="loadingDiscardLivestream" block primary @click="finish('discarded')" style="margin-left: 5px">
                <span class="content-4">Discard</span>
              </cp-button>
            </div>
          </div>
        </cp-dialog>

        <!-- Video sahred Modal -->
        <cp-dialog v-if="showSharedModal">
          <div class="container-modal" style="margin-left: 50px; margin-right: 50px">
            <img :src="'/assets/img/icons/icon-green-check.svg'" />
            <h3 style="margin: 0; padding-top: 20px; color: #404040">Video saved and shared!</h3>
            <p class="content-3" style="margin-left: 20px; margin-right: 20px">
              Your livestream was successfully saved and shared on CrowdBlue TV. Head over there to view your shared video and relive the moment!
            </p>

            <div style="margin-top: 40px">
              <cp-button :loading="loadingSaveLivestream" block primary @click="finish('shared')" style="margin-left: 5px">
                <span class="content-4">Ok</span>
              </cp-button>
            </div>
          </div>
        </cp-dialog>
      </div>
    </template>
  </div>
</template>

<script>
import OT from '@opentok/client'; // Vonage client SDK
import fire from '../firebase';
import * as API from '../api/livestreams';

const db = fire.firestore();

export default {
  name: 'CpLivestreamStart',
  components: {
    CpButton: require('../button').default,
    CpIcon: require('../icon').default,
    CpTextInput: require('../inputs/text').default,
    CpDialog: require('../dialog').default,
    CpBox: require('../box').default,
    CpBoxContent: require('../box-content').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpAuthForm : require('../auth-form/index').default,
    CpSignInfo: require('../auth-form/sign-info').default,
  },
  props: {
    user: Object,
    returnUrl: String,
  },
  data() {
    return {
      step: 'add-title', // start-livestream and livestream-ended
      title: '',
      showChat: false,
      streamSession: null,
      streamPublisher: null,
      showStreamEndedModal: false,
      showDiscardModal: false,
      showSharedModal: false,
      showStartingLivestreamModal: false,
      errorStartingLivestream: null,
      livestream: null,
      loadingSaveLivestream: false,
      loadingDiscardLivestream: false,
      // Timer
      timer: null,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    goFeed() {
      window.location.href = '/feed#tv';
    },
    handleErrorStartingLivestream() {
      this.showStartingLivestreamModal = false;
      this.errorStartingLivestream = null;
      this.livestream = null;

      window.location.reload();
    },
    async finish(status) {
      if (status == 'shared') this.showSharedModal = false;
      else {
        try {
          this.loadingDiscardLivestream = true;
          // Update status in database
          await API.updateLivestreamStatus(this.livestream.id, { status: 'discarded' });

          // Livestream discarded - set status in firestore
          db.collection('livestreams').doc(this.livestream.id).set({ status: 'discarded' }, { merge: true });
          this.showDiscardModal = false;
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingDiscardLivestream = false;
        }
      }
      this.goFeed();
    },
    async saveLivestream() {
      // TODO: Save the livestreams in the database and get them from there
      try {
        this.loadingSaveLivestream = true;

        // Update status in database
        await API.updateLivestreamStatus(this.livestream.id, { status: 'shared' });

        this.showSharedModal = true;
      } catch (error) {
        console.warn(error);
        alert('Failed to save the livestream, please try again!');
      } finally {
        this.loadingSaveLivestream = false;
      }
    },
    discardLivestream() {
      this.showDiscardModal = true;
      // TODO: We must delete all discarded livestreams from s3
    },
    setStep(step) {
      this.step = step;
      if (step == 'start-livestream') {
        // Hidden footer
        document.querySelector('.site-footer').style.display = 'none';
        document.querySelector('.site-header__button-group').style.display = 'none';

        // Loading
        this.showStartingLivestreamModal = true;

        // We wait 0.5 second for the div with id publisher to render
        setTimeout(() => {
          this.startLivestream(); // Start Livestream
        }, 250);
      }
    },
    handleChat() {
      this.showChat = !this.showChat;
    },
    handleError(error) {
      if (error) {
        console.error('Error: ', error.message);
        this.errorStartingLivestream = 'Error [Callback]: ' + error.message;
      }
    },
    listenLivestreamChanges(sessionId) {
      let attributeBannedByAdminAdded = false;
      db.collection('livestreams')
        .doc(sessionId)
        .onSnapshot(
          docSnapshot => {
            const data = docSnapshot.data();

            // Livestream banned
            if (data && !attributeBannedByAdminAdded && data.bannedByAdmin) {
              attributeBannedByAdminAdded = true;
              this.stopLivestream(sessionId);
              alert('The livestream was banned by the administrator');
            }
          },
          err => {
            console.log(`Error getting livestream: ${err}`);
          },
        );
    },
    async broadcastStream(error, session) {
      if (error) {
        console.error('Error publishing to session: ', error);
        this.errorStartingLivestream = 'Error publishing to session: ' + error.message;
      } else {
        try {
          // Start broadcast and Save livestream on DB
          const { sessionId, broadcastUrls, broadcastId } = await API.startBroadcast({ id: session.sessionId, title: this.title });

          // The livestream can start ✓
          this.streamSession = session;
          this.listenLivestreamChanges(sessionId);

          // Save in firestore
          const livestream = {
            id: sessionId,
            title: this.title,
            broadcastId,
            broadcastUrls,
            status: 'live',
            type: 'livestream',
            viewers: 0,
            user: {
              id: this.user.id,
              profile_image: this.user.profile_image,
              name: this.user.name,
              slug: this.user.slug,
            },
            createdAt: Date.now(),
          };

          await db.collection('livestreams').doc(livestream.id).set(livestream);
          this.livestream = livestream;

          // Listen viewers changes
          db.collection('livestreams')
            .doc(livestream.id)
            .onSnapshot(
              docSnapshot => {
                const data = docSnapshot.data();
                this.livestream.viewers = data.viewers; // Update viewers

                // Livestream finished
                if (data && data.status != 'live') {
                  this.livestream = { ...this.livestream, status: data.status };
                }
              },
              err => {
                console.log(`Encountered error: ${err}`);
              },
            );

          this.showStartingLivestreamModal = false; // Hidde loading

          this.startTimer(); // Time counter
        } catch (error) {
          console.error('Failed to start broadcast: ', error);
          this.errorStartingLivestream = 'Error [Broadcast]: ' + error.message;

          session.unpublish(this.streamPublisher);
          session.disconnect();
        }
      }
    },
    async startLivestream() {
      try {
        const { sessionId, publisherToken } = await API.createSession({});
        const apikey = process.env.MIX_VONAGE_API_KEY;

        const session = OT.initSession(apikey, sessionId);

        // Initialize the publisher
        const publisherOptions = {
          insertMode: 'append',
          width: '100%',
          height: '100%',
        };

        const publisher = OT.initPublisher('publisher', publisherOptions, this.handleError);
        this.streamPublisher = publisher;

        // Connect to the session
        session.connect(publisherToken, error => {
          if (error) this.handleError(error);
          else session.publish(publisher, error => this.broadcastStream(error, session));
        });
      } catch ({ message }) {
        console.error('Error starting livestream [Method]: ' + message);
        this.errorStartingLivestream = 'Error [Method]: ' + message;
      }
    },
    handleEndLivestreamModal() {
      this.showStreamEndedModal = !this.showStreamEndedModal;
    },
    async stopLivestream(id) {
      const sessionId = this.streamSession.sessionId || id;
      try {
        // Stop in Vonage
        if (this.streamPublisher) this.streamSession.unpublish(this.streamPublisher);
        if (this.streamSession) this.streamSession.disconnect();

        this.streamSession = null;
        this.showStreamEndedModal = false;
        this.step = 'livestream-ended';

        // Update status in firestore
        const livestreamRef = db.collection('livestreams').doc(sessionId);
        await livestreamRef.update({ status: 'finished' });

        // Update status in database
        await API.updateLivestreamStatus(this.livestream.id, { status: 'finished' });

        this.stopTimer();
      } catch (error) {
        console.log(error);
        alert('Error stopping livestream: ', error.message);
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.seconds++;
        if (this.seconds === 60) {
          this.seconds = 0;
          this.minutes++;
        }
        if (this.minutes === 60) {
          this.minutes = 0;
          this.hours++;
        }
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
    },
  },
  computed: {
    displayTime() {
      const displayHours = this.hours < 10 ? `0${this.hours}` : this.hours;
      const displayMinutes = this.minutes < 10 ? `0${this.minutes}` : this.minutes;
      const displaySeconds = this.seconds < 10 ? `0${this.seconds}` : this.seconds;
      return `${displayHours}:${displayMinutes}:${displaySeconds}`;
    },
    liveViewers() {
      return this.livestream?.viewers || 0;
    },
  },
};
</script>

<style scoped>
/* LIVESTREAM TITLE SECTION */
.container-livestream {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f3f3;
  height: 90vh;
}
.box-livestream {
  display: flex;
  flex-direction: column;
  width: 60%;
  height: 70%;
  padding: 25px;
  justify-content: space-between;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
}

/* START LIVESTREAM SECTION */

#publisher {
  width: 50%;
  height: 80vh;
}
.container-start-livestream {
  background-color: black;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #232323;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid gray;
}
.body {
  flex: 1;
  display: flex;
  position: relative;
}
.video-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chat-content {
  position: absolute;
  right: 0;
  width: 25%;
  height: -webkit-fill-available;
  padding: 15px;
  border-left: 1px solid gray;
  background-color: transparent;
  background-image: linear-gradient(to right, rgba(169, 73, 73, 0), rgb(175, 91, 91));
}
.user-image {
  border: 2px solid #fcd9d0;
  border-radius: 50px;
  margin-right: 10px;
  width: 35px;
  height: 35px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #232323;
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid gray;
}
.icon {
  color: white;
  margin-left: 10px;
  size: 50px;
}
.viewer-badge {
  display: flex;
  align-items: center;
  display: inline;
  color: white;
  padding: 5px 8px;
  text-align: center;
  border-radius: 5px;
  font-size: 11px;
  background-color: rgba(0, 0, 0, 0.4);
}
.live-badge {
  color: white;
  padding: 6px 9px;
  text-align: center;
  border-radius: 5px;
  font-size: 13px;
  background-color: #ed572f;
}

/* Modal ended style */
.container-modal {
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
  align-items: center;
}

@media screen and (max-width: 768px) {
  #publisher {
    width: 100%;
  }
}

/* Mobile start livestream*/
@media (max-width: 426px) {
  .body {
    flex-direction: column;
    position: relative;
  }
  .video-content {
    height: 100%;
  }
  .chat-content {
    position: absolute;
    border: none;
    bottom: 0;
    width: -webkit-fill-available;
    height: 50%;
    background-color: transparent;
    background-image: linear-gradient(to bottom, rgba(162, 32, 32, 0), rgb(181, 57, 57));
  }
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner-inner {
  border: 4px solid rgba(0, 0, 0, 0.3);
  border-top: 4px solid #ed572f;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
